import { MemberInterface, MemberInviteInterface } from '@swivl-mono/types';
import { Avatar, Button, ButtonColor, LayoutHeader } from '@swivl-mono/ui';
import MembersModel from '../../../../Models/Member/Members.Model';
import { DateTime } from 'luxon';
import React, { useEffect } from 'react';
import { MemberOrInvitePermissionsRole } from './Role/MemberOrInvitePermissionsRole.View';
import LocationsModel from '../../../../Models/Locations/Locations.Model';
import { AlertsModel } from '../../../../Models/Notifications/Alerts.Model';
import { DateHelper } from '@swivl-mono/helpers';
interface Props {
  invite: MemberInviteInterface;
}
export function InvitePermissionsView(props: Props) {
  const { invite } = props;
  useEffect(() => {
    LocationsModel.getGroupsAndLocations(false);
  }, []);



  return (
    <div className="flex flex-col px-6 pb-6">
      <LayoutHeader noPadding={true}>
        <h2 >{invite.firstName} {invite.lastName}<label>PENDING INVITE</label></h2>

        <Button
          className="ml-2"
          onClickAsync={async () => {
            if (window.confirm("Are you sure you want to resend this invite?")) {
              MembersModel.resendInvite(invite).then(() => {
                AlertsModel.successToast("Invite Resent");
              }).catch((e) => {
                AlertsModel.errorToast("Error Resending Invite");
              })
            }
          }}>
          Resend Invite
        </Button>

        <Button
          color={ButtonColor.WHITE}
          className="ml-2"
          onClickAsync={async () => {
            if (window.confirm("Are you sure you want to delete this invite?")) {

              MembersModel.deleteInvite(invite);
            }
          }}>
          Delete Invite
        </Button>
      </LayoutHeader>

      <div className="flex flex-row pb-3 items-center">
        <p className="font-semibold">Email:</p>
        <p className="pl-2">{invite.email}</p>
      </div>
      <div className="flex flex-row pb-3 items-center">
        <p className="font-semibold">Sent by:</p>
        <p className="pl-2">
          {invite.sentByMember?.account.firstName} {invite.sentByMember?.account.lastName} @ {DateHelper.dateTime(invite.createdAt).toLocaleString(DateTime.DATETIME_SHORT)}
        </p>
      </div>

      <h3>Permissions</h3>
      {!invite.permissions?.length ? (
        <div className="flex flex-row pb-3 items-center">
          <p className="font-semibold">This member has no assigned roles.</p>
        </div>
      ) : (
        invite.permissions.map((permission) => (
          <MemberOrInvitePermissionsRole invite={invite} memberPermission={permission} key={permission.id} />
        ))
      )}
    </div>
  );
}
